import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL ?? window.location.origin,
  timeout: 30000, // Increased for file uploads
  // Remove manual Content-Type—Axios sets it automatically for FormData
});

// Request Interceptor: Dynamically fetch latest token from localStorage
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    console.error('Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor: Handle 401 (e.g., expired token) globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Axios Response Error:', error.response?.data || error.message); // Added logging
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      console.warn('Token expired or invalid. Redirecting to login.');
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
